var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEsia = function SvgEsia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#esia_svg__a)",
    d: "M17.975 7.053c-.069-.902-.757-2.059-1.445-2.614a26.248 26.248 0 0 0-2.407-1.573 26.745 26.745 0 0 0-2.545-1.341 3.693 3.693 0 0 0-1.468-.278 3.616 3.616 0 0 0-1.467.278 26.91 26.91 0 0 0-2.546 1.341C4.767 3.676 3.69 4.44 3.69 4.44a4.28 4.28 0 0 0-1.267 1.828c-.041.114.046.23.167.23h1.143a.387.387 0 0 0 .328-.19c.197-.325.448-.619.744-.867 0 0 .89-.626 1.988-1.29.68-.404 1.382-.77 2.101-1.1a3.004 3.004 0 0 1 1.212-.227c.415-.007.827.07 1.212.227.72.329 1.42.696 2.101 1.1.686.394 1.35.824 1.988 1.29.568.455 1.136 1.403 1.193 2.143 0 0 .133 1.1.151 2.403a22.539 22.539 0 0 1-.132 2.409 3.51 3.51 0 0 1-1.212 2.143s-.89.645-1.988 1.309c-.68.404-1.382.77-2.101 1.1a3.002 3.002 0 0 1-1.212.227 3.069 3.069 0 0 1-1.212-.221 22.13 22.13 0 0 1-2.101-1.1c-1.098-.645-1.988-1.31-1.988-1.31a3.42 3.42 0 0 1-.727-.858.383.383 0 0 0-.323-.186h-1.16c-.123 0-.21.12-.166.234.273.702.767 1.41 1.26 1.808 0 0 1.079.81 2.408 1.596.824.493 1.674.941 2.546 1.342.466.19.965.281 1.467.27a3.615 3.615 0 0 0 1.468-.277c.871-.401 1.72-.85 2.545-1.341a38.777 38.777 0 0 0 2.407-1.596 4.288 4.288 0 0 0 1.468-2.614c.105-.976.159-1.956.16-2.938a31.455 31.455 0 0 0-.183-2.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0066B3",
    d: "M2.062 8.074a.35.35 0 0 1 .35-.35h5.42a.35.35 0 0 1 .35.35v1.05a.35.35 0 0 1-.35.35h-5.77v-1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE2F53",
    d: "M2.062 10.524h11.017a.35.35 0 0 1 .35.35v1.05a.35.35 0 0 1-.35.35H2.41a.35.35 0 0 1-.35-.35v-1.4Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "esia_svg__a",
    x1: 10.252,
    x2: 10.252,
    y1: 1.247,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#EE2F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2F53"
  })))));
};
export default SvgEsia;